exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flash-plugin-button[data-v-b4e2aef2] {\n    color: #ccc;\n    font-size: 13px;\n    line-height: 20px;\n    cursor: pointer;\n}\n", ""]);

// exports
